import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "../data/siteData";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-forest-deep text-brand-cream/80 pt-20 pb-10"
    >
      <div className="container-app">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span
                className="block h-14 w-14 rounded-full border-2 border-brand-gold bg-white shrink-0 overflow-hidden"
                aria-hidden="true"
              >
                <img
                  src="/javier-headshot.jpg"
                  alt=""
                  className="h-full w-full object-cover"
                />
              </span>
              <p className="font-heading text-xl font-bold text-brand-cream leading-tight">
                J K Awesome Deeds <span className="text-brand-gold">LLC</span>
              </p>
            </div>
            <p className="mt-6 text-sm leading-relaxed max-w-md">
              Real estate solutions built on compassion. Helping Florida
              homeowners stop foreclosure, navigate short sales, and sell for
              cash since 2014.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-semibold text-brand-cream mb-4">
              Programs
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="#services" className="hover:text-brand-gold transition-colors">
                  Pre-Foreclosure Help
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-brand-gold transition-colors">
                  Short Sales Expedited
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-brand-gold transition-colors">
                  Fidelity House Buyers
                </a>
              </li>
              <li>
                <a href="#about" className="hover:text-brand-gold transition-colors">
                  About Javier
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-semibold text-brand-cream mb-4">
              Contact
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-brand-gold flex-shrink-0 mt-0.5" />
                <div>
                  <a
                    href={`tel:${CONTACT.phone}`}
                    data-testid="footer-phone"
                    className="hover:text-brand-gold transition-colors block font-semibold text-brand-cream"
                  >
                    {CONTACT.phone}
                  </a>
                  <span className="text-xs text-brand-cream/60">
                    {CONTACT.phoneNote}
                  </span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-brand-gold flex-shrink-0 mt-0.5" />
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="hover:text-brand-gold transition-colors break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-brand-gold flex-shrink-0 mt-0.5" />
                <span>Serving all of Florida</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-cream/10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
          <p className="text-xs text-brand-cream/50">
            © {new Date().getFullYear()} J K Awesome Deeds LLC. All rights reserved.
          </p>
          <p className="text-xs text-brand-cream/50">
            J K Awesome Deeds LLC is a Florida-registered for-profit investment
            company — not a licensed real estate brokerage, lender, attorney,
            credit counselor, or tax professional. Always consult appropriate
            licensed professionals.
          </p>
        </div>
      </div>
    </footer>
  );
};
